// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"9150eb7d","305":"3c9be4a3"}[chunkId] + ".chunk.css";
};